import AccordianDownIcon from '../../assets/AccordianDownIcon';
import AccordianDownIconDark from '../../assets/AccordianDownIconDark';
import AccordianUpIcon from '../../assets/AccordianUpIcon';
import AccordianUpIconDark from '../../assets/AccordianUpIconDark';
import BallIcon from '../../assets/BallIcon';
import EditIcon from '../../assets/EditIcon';
import EditIconDark from '../../assets/EditIconDark';
import useBgColorStore from '../../store/bgColor';
import PilotHoursCard from './PilotHoursCard';
import Accordion from '../../components/common/Accordian';
import DriverSummary from './DriverSummary';
import { IDriverSummary } from '../../type/driverSummary';
import { formatDateToDDMMYYYY, getAdjustedDate } from '../../utils/dateUtils';

interface DriverHourList {
  driverSummary: IDriverSummary[];
}

// export default function PilotHoursList({ pilotSummary }: PilotHourList) {

export default function DriverHourList({ driverSummary }: DriverHourList) {
   const dateTime = formatDateToDDMMYYYY(getAdjustedDate());
  const { bgColor, updateBgColor } = useBgColorStore();
  return (
    <>
      <div className="mt-4">
        <Accordion
          title={`Driver Summary ${dateTime}`}
          iconOpen={
            <div>
              <div className="block dark:hidden">
                <AccordianDownIcon />
              </div>
              <div className="hidden dark:block">
                <AccordianDownIconDark />
              </div>
            </div>
          }
          iconClose={
            <div>
              <div className="block dark:hidden">
                <AccordianUpIcon />
              </div>
              <div className="hidden dark:block">
                <AccordianUpIconDark />
              </div>
            </div>
          }
          bgColor={`${bgColor}`}
        >
          {driverSummary.map((res) => {
            return (
              <>
                <Accordion
                  key={1}
                  title={res?.staffName}
                  bgColor="bg-backgroundColor-darkThemeColor"
                  status={''}
                >
                  <DriverSummary
                    restDaysIn14={`${res?.minRestDays}/${res?.restDays}`}
                    consecRestDays={`${res?.minConsecRestDays}/${res?.consecRestDays}`}
                    kkDaysIn14={`${res?.workDays}/${res?.maxWorkDays}`}
                    consecKKDays={`${res?.consecWorkDays}/${res?.maxConsecWorkDays}`}
                    kkd={res?.kkd}
                    style={res?.compliantStyle}
                    consecWorkStyle={res?.consecWorkStyle}
                    restStyle={res?.restStyle}
                    consecRestStyle={res?.consecRestStyle}
                    workStyle={res?.workStyle}
                  />
                </Accordion>
              </>
            );
          })}
        </Accordion>
      </div>
    </>
  );
}
